import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const InstagramIcon = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M24.003,17.845c-3.406,0 -6.152,2.747 -6.152,6.152c0,3.406 2.746,6.152 6.152,6.152c3.405,0 6.152,-2.746 6.152,-6.152c0,-3.405 -2.747,-6.152 -6.152,-6.152Zm0,10.152c-2.201,0 -4,-1.794 -4,-4c0,-2.206 1.794,-3.999 4,-3.999c2.206,0 3.999,1.793 3.999,3.999c0,2.206 -1.799,4 -3.999,4Zm7.838,-10.403c0,-0.793 -0.642,-1.435 -1.435,-1.435c-0.792,0 -1.435,0.642 -1.435,1.435c0,0.792 0.637,1.435 1.435,1.435c0.793,0 1.435,-0.637 1.435,-1.435Zm4.075,1.456c-0.091,-1.922 -0.53,-3.625 -1.939,-5.027c-1.402,-1.403 -3.105,-1.842 -5.027,-1.939c-1.981,-0.112 -7.919,-0.112 -9.9,0c-1.917,0.091 -3.619,0.53 -5.027,1.933c-1.409,1.403 -1.842,3.106 -1.939,5.028c-0.112,1.981 -0.112,7.919 0,9.9c0.091,1.922 0.53,3.624 1.939,5.027c1.408,1.403 3.105,1.842 5.027,1.938c1.981,0.113 7.919,0.113 9.9,0c1.922,-0.091 3.625,-0.53 5.027,-1.938c1.403,-1.403 1.842,-3.105 1.939,-5.027c0.112,-1.981 0.112,-7.914 0,-9.895Zm-2.56,12.02c-0.417,1.05 -1.226,1.858 -2.28,2.281c-1.58,0.626 -5.328,0.482 -7.073,0.482c-1.746,0 -5.499,0.139 -7.073,-0.482c-1.05,-0.418 -1.858,-1.226 -2.281,-2.281c-0.626,-1.579 -0.482,-5.327 -0.482,-7.073c0,-1.745 -0.139,-5.498 0.482,-7.073c0.418,-1.049 1.226,-1.857 2.281,-2.28c1.579,-0.627 5.327,-0.482 7.073,-0.482c1.745,0 5.498,-0.139 7.073,0.482c1.049,0.417 1.857,1.226 2.28,2.28c0.627,1.58 0.482,5.328 0.482,7.073c0,1.746 0.145,5.499 -0.482,7.073Z" fill={fill} fillRule={"nonzero"}/>
    </svg>
  );
};

InstagramIcon.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

InstagramIcon.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};